<template>
  <div class="grid__thumbnails">
    <b-button
      v-for="(image, index) in displayImages"
      :key="`image-${image.id}`"
      variant="transparent"
      class="p-0"
      @click="onClickImage(index)"
    >
      <base-thumbnail-image
        :file="image"
        width="100%"
        height="100%"
        background-position="center"
      ></base-thumbnail-image>
    </b-button>

    <b-button
      v-if="hiddenThumbnailLength > 0"
      ref="thumbnail--hidden"
      variant="transparent"
      class="p-0"
      @click="onClickImage(3)"
    >
      <base-thumbnail-image
        :text="`+${hiddenThumbnailLength}`"
        width="100%"
        height="100%"
        static
        background-variant="gray"
        text-font-size="40px"
        text-variant="dark"
        text-font-weight="bold"
      ></base-thumbnail-image>
    </b-button>

    <base-image-modal
      :key="`images-modal-${keyId}`"
      :show.sync="activeImageModal"
      :images="images"
      :index-active.sync="indexActive"
    ></base-image-modal>
  </div>
</template>

<script>
import BaseThumbnailImage from '@/components/base-components/BaseThumbnailImage';
import BaseImageModal from '@/components/base-components/BaseImageModal';

export default {
  components: {
    BaseThumbnailImage,
    BaseImageModal
  },

  props: {
    images: {
      type: Array,
      default: () => []
    },

    maximumDisplayImages: {
      type: Number,
      default: 3
    },

    keyId: {
      type: [Number, String],
      default: null
    }
  },

  data() {
    return {
      activeImageModal: false,
      indexActive: 0
    };
  },

  computed: {
    displayImages() {
      const { images = [] } = this;

      return images.slice(0, this.maximumDisplayImages);
    },

    imageLength() {
      const { images = [] } = this;

      return images.length;
    },

    hiddenThumbnailLength() {
      return this.imageLength > this.maximumDisplayImages
        ? this.imageLength - this.maximumDisplayImages
        : 0;
    }
  },

  methods: {
    onClickImage(index) {
      this.indexActive = index;
      this.activeImageModal = true;
    }
  }
};
</script>
